// Verde vocabulary expansion — BODY & HEALTH theme (net-new cards).
//
// Extends the `body-health` blocks in ./vocabulary.js without reusing any
// headword already defined there. Seed upserts on `spanish`, so every value is
// unique.
//   [ spanish, english, emoji, part_of_speech, gender, example_es, example_en ]

export const VOCAB_BODY_HEALTH = [
  {
    theme: "body-health", tier: "A1", rows: [
      ["la oreja", "ear", "👂", "noun", "f", "Me duele la oreja izquierda.", "My left ear hurts."],
      ["el diente", "tooth", "🦷", "noun", "m", "Me lavo los dientes después de comer.", "I brush my teeth after eating."],
      ["el dedo", "finger", "🫰", "noun", "m", "Me he cortado el dedo.", "I've cut my finger."],
      ["la espalda", "back", "🧍", "noun", "f", "Me duele la espalda por la noche.", "My back hurts at night."],
      ["el cuello", "neck", "🧣", "noun", "m", "Tengo el cuello rígido.", "My neck is stiff."],
      ["la rodilla", "knee", "🦵", "noun", "f", "Me hice daño en la rodilla.", "I hurt my knee."],
      ["el corazón", "heart", "❤️", "noun", "m", "El corazón late muy rápido.", "The heart beats very fast."],
      ["el estómago", "stomach", "🤰", "noun", "m", "Me duele el estómago.", "My stomach hurts."],
      ["la garganta", "throat", "🗣️", "noun", "f", "Tengo la garganta irritada.", "My throat is sore."],
      ["el hombro", "shoulder", "💪", "noun", "m", "Llevo la mochila en un hombro.", "I carry the backpack on one shoulder."],
    ],
  },
  {
    theme: "body-health", tier: "A2", rows: [
      ["el resfriado", "cold (illness)", "🤧", "noun", "m", "Tengo un resfriado muy fuerte.", "I have a bad cold."],
      ["la gripe", "flu", "🌡️", "noun", "f", "Está en cama con gripe.", "She's in bed with the flu."],
      ["la tos", "cough", "😷", "noun", "f", "La tos no me deja dormir.", "The cough won't let me sleep."],
      ["la venda", "bandage", "🩹", "noun", "f", "El médico me puso una venda.", "The doctor put a bandage on me."],
      ["la tirita", "plaster / band-aid", "🩹", "noun", "f", "Necesito una tirita para el dedo.", "I need a plaster for my finger."],
      ["el jarabe", "syrup (medicine)", "🍶", "noun", "m", "Toma el jarabe para la tos.", "Take the cough syrup."],
      ["la consulta", "doctor's office / appointment", "🏥", "noun", "f", "La consulta abre a las nueve.", "The surgery opens at nine."],
      ["doler", "to hurt", "😣", "verb", "", "Me duele todo el cuerpo.", "My whole body aches."],
      ["engordar", "to put on weight", "⚖️", "verb", "", "He engordado dos kilos.", "I've put on two kilos."],
      ["adelgazar", "to lose weight", "📉", "verb", "", "Quiere adelgazar para el verano.", "She wants to lose weight for the summer."],
    ],
  },
  {
    theme: "body-health", tier: "B1", rows: [
      ["el malestar", "discomfort / unwellness", "😖", "noun", "m", "Siento un malestar general.", "I feel a general unwellness."],
      ["el diagnóstico", "diagnosis", "🩺", "noun", "m", "El diagnóstico tardó una semana.", "The diagnosis took a week."],
      ["la dolencia", "ailment", "🤕", "noun", "f", "Es una dolencia crónica pero leve.", "It's a chronic but mild ailment."],
      ["crónico", "chronic", "♾️", "adjective", "", "Sufre de dolor crónico de espalda.", "He suffers from chronic back pain."],
      ["agudo", "acute / sharp", "⚡", "adjective", "", "Sintió un dolor agudo en el pecho.", "He felt a sharp pain in his chest."],
      ["el ingreso", "hospital admission", "🛏️", "noun", "m", "El ingreso fue de urgencia.", "The admission was an emergency."],
      ["la baja médica", "sick leave", "📋", "phrase", "", "Está de baja médica dos semanas.", "She's on sick leave for two weeks."],
      ["desmayarse", "to faint", "😵", "verb", "", "Se desmayó por el calor.", "He fainted from the heat."],
      ["la cicatriz", "scar", "➰", "noun", "f", "Le quedó una cicatriz pequeña.", "He was left with a small scar."],
      ["aliviar", "to relieve", "🌿", "verb", "", "La pastilla alivia el dolor enseguida.", "The pill relieves the pain right away."],
    ],
  },
];
